import { FC } from 'react';

type ModelliStatCardProps = {
  label: string;
  value: number | null;
};

export const ModelliStatCard: FC<ModelliStatCardProps> = ({ label, value }) => (
  <div className='rounded-xl border border-gray-200 px-4 py-3'>
    {value === null ? (
      <div className='h-8 w-12 animate-pulse rounded bg-gray-100' aria-hidden />
    ) : (
      <div className='text-2xl font-extrabold text-primary-900'>{value}</div>
    )}
    <div className='mt-0.5 text-xs font-medium text-tertiary-600'>{label}</div>
  </div>
);
